import React, { ReactNode } from "react";
import { Empty, Spin } from "antd";
import styles from "./charts.module.scss";

interface Props {
  title: string;
  description?: string;
  isLoading?: boolean;
  hasData?: boolean;
  children: ReactNode;
}

function ChartCard({ title, description, isLoading, hasData = true, children }: Props) {
  return (
    <div className={styles.card}>
      <div className={styles.cardTitle}>{title}</div>
      {description && <div className={styles.cardDescription}>{description}</div>}

      <Spin spinning={Boolean(isLoading)}>
        <div className={styles.cardBody}>
          {hasData || isLoading ? (
            children
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No feedback in this range" />
          )}
        </div>
      </Spin>
    </div>
  );
}

export default ChartCard;
